export enum BatchInitiationOption {
  BY_QUANTITY = 'by_quantity',
  BY_DATE_AND_TIME = 'by_date_and_time',
  BY_USER_ONLY = 'by_user_only'
}
